import React, { useEffect, Fragment } from 'react';
import { func, array } from 'prop-types';
import classNames from 'classnames/bind';

import { withErrorBoundary } from 'containers/ErrorBoundary';

import IconArrowDown from 'media/icons/arrow-down.icon.svg';
import styles from './SelectLinkedBrand.module.scss';
const cx = classNames.bind(styles);

const SelectLinkedBrand = ({ setManuLinkedId, brands }) => {
  const changeBrand = (event) => {
    setManuLinkedId(Number(event.target.value));
  };

  useEffect(() => {
    setManuLinkedId(brands[0].manuId);
  }, []);

  return (
    <Fragment>
      {brands && (
        <div className={cx('select-container', 'oe-select')}>
          <span className={cx('arrow')}>
            <IconArrowDown className={cx('icon')} />
          </span>
          <select className={cx('select')} onChange={changeBrand}>
            {brands.map((item) => (
              <option key={item.manuId} value={item.manuId}>
                {item.manuName}
              </option>
            ))}
          </select>
        </div>
      )}
    </Fragment>
  );
};

SelectLinkedBrand.propTypes = {
  brands: array,
  setManuLinkedId: func.isRequired,
};

SelectLinkedBrand.defaultProps = {
  brands: [],
};

export default withErrorBoundary(SelectLinkedBrand);



// WEBPACK FOOTER //
// ./src/pages/Product/components/TabLinkedVehicles/components/SelectLinkedBrand/SelectLinkedBrand.js